import { render, staticRenderFns } from "./DiarioFaturamentoChart.vue?vue&type=template&id=7139bd92"
import script from "./DiarioFaturamentoChart.vue?vue&type=script&lang=js"
export * from "./DiarioFaturamentoChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports